var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Doctor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u041B\\u0438\\u0447\\u043D\\u044B\\u0439-\\u043A\\u0430\\u0431\\u0438\\u043D\\u0435\\u0442_\\u043F\\u0430\\u0446\\u0438\\u0435\\u043D\\u0442_\\u043C\\u043E\\u0438-\\u043F\\u0430\\u0446\\u0438\\u0435\\u043D\\u0442\\u044B",
    transform: "translate(-1291.000000, -208.000000)",
    fill: "#00C5D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1129.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(157.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6146397,7.24071483 C17.93156,6.91976172 18.4453894,6.91976172 18.7623097,7.24071483 C19.0440167,7.52600648 19.0753175,7.96886036 18.8562121,8.28916584 L18.7623097,8.40298885 L10.5110101,16.7592852 C10.2293032,17.0445768 9.79201373,17.0762759 9.47573289,16.8543824 L9.36334006,16.7592852 L5.23769025,12.581137 C4.92076992,12.2601839 4.92076992,11.7398161 5.23769025,11.418863 C5.51939722,11.1335713 5.95668665,11.1018723 6.2729675,11.3237658 L6.38536032,11.418863 L9.93677884,15.015795 L17.6146397,7.24071483 Z",
    id: "Path-10"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.092e6408e2f3b547236cf4184eabc6e7.svg";
export { ForwardRef as ReactComponent };